import { render, staticRenderFns } from "./processes.vue?vue&type=template&id=4ac3bd33&scoped=true&"
import script from "./processes.vue?vue&type=script&lang=js&"
export * from "./processes.vue?vue&type=script&lang=js&"
import style0 from "./processes.vue?vue&type=style&index=0&id=4ac3bd33&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac3bd33",
  null
  
)

export default component.exports